import { 
  Box, 
  Button, 
  FormControl, 
  FormHelperText, 
  Grid, IconButton, 
  InputAdornment, 
  TextField, 
  Typography, 
  styled, 
  useMediaQuery,
  Checkbox,
  CircularProgress,
 } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleIcon from '@mui/icons-material/Circle'
import ErrorIcon from '@mui/icons-material/Error';
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { useEffect, useState } from "react";
import { isValidEmail } from "../../libs/utils";
import EmailVerifyModal from "./EmailVerifyModal";
import {
  MutateCreateAffiliateCode,
  MutateGenerateVerificationCode,
  MutateVerifyAgent,
  MutateVerifyEmail,
} from '../../libs/hooks/mutations'
import { useContext } from 'react'
import { AuthContext } from '../../libs/contexts/authContext'
import { QueryContext } from '../../libs/contexts/queryContext'

export const StyledTextField = styled(TextField)({
  width: '100%',
  backgroundColor: 'white',
  fontSize: '16px',
})

export function checkUppercase(str) {
  console.log({str})
  if (!str) return false
  for (let i = 0; i < str.length; i++) {
    if (str.charAt(i) === str.charAt(i).toUpperCase() && str.charAt(i).match(/[a-z]/i)) {
      return true
    }
  }
  return false
}
export function checkLowerCase(str) {
  if (!str) return false
  for (let i = 0; i < str.length; i++) {
    if (str.charAt(i) === str.charAt(i).toLowerCase() && str.charAt(i).match(/[a-z]/i)) {
      return true
    }
  }
  return false
}
const SPECIAL_CHARS = '!@#$%^&*()'

export function checkSpecialChars(str) {
  if (!str) return false
  const alreadyFoundChars = []
  for (let i = 0; i < str.length; i++) {
    const currentChar = str[i]
    if (!alreadyFoundChars.includes(currentChar)) {
      if (SPECIAL_CHARS.includes(currentChar)) {
        alreadyFoundChars.push(currentChar)
      }
    }
  }
  return alreadyFoundChars.length >= 1
}

const FirstRegisterStepV2 = ({
  registrationForm,
  setRegistrationForm,
  // handleRegistrationFormChange,
  // handleNext,
  setErrorContent,
  setAgentVerifyError,
  workAddress,
  setWorkAddress,
  personalAddress,
  setPersonalAddress,
  companyInfo,
  setCompanyInfo,
  agreedCheckbox,
  setAgreedCheckbox,
  loading,
  handleSubmit
}) => {
  const { firstName, lastName, producerNumber, workEmail, password, confirmPassword } = registrationForm
  const { producerId } = companyInfo

  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [showPasswordChecks, setShowPasswordChecks] = useState(false)
  const [error, setError] = useState({
    firstName,
    lastName,
    password: false,
    confirmPassword: false,
    workEmail: false,
    producerId: false,
    agreeToTerms: false,
  })
  const [showVerifyModal, setShowVerifyModal] = useState(false)
  const [codeGenerated, setCodeGenerated] = useState(false)

  const [verificationError, setVerificationError] = useState(false)

  const { affiliateCode } = useContext(AuthContext)
  const { verifiedEmail, setVerifiedEmail, verifiedAgentCode, setVerifiedAgentCode } = useContext(QueryContext)

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  const {
    mutate: generateCode,
    data: generateCodeRes,
    isError: isGenerateCodeError,
    error: generateCodeError,
  } = MutateGenerateVerificationCode()
  const { mutate: verifyEmail, data: verifyEmailRes, isError: verifyError } = MutateVerifyEmail()
  const { mutate: verifyAgent, data: verifyAgentRes, isPending: verifyingAgent, isError: isVerifyAgentError, error: verifyAgentError } = MutateVerifyAgent()
  const {
    mutate: createAffiliateCode,
    data: createAffiliateCodeRes,
    isError: isCreatreAffiliateCodeError,
    error: createAffiliateCodeError,
    isPending: creatingAffiliateCode,
    isSuccess: createAffiliateCodeSuccess,
  } = MutateCreateAffiliateCode()

  const errorFree = Object.values(error).every((v) => v === false)

  useEffect(() => {
    if (!generateCodeRes) return
    console.log({ generateCodeRes })
    if (generateCodeRes.statusCode === 200) {
      setCodeGenerated(true)
    }

    return () => {
      setCodeGenerated(false)
    }
  }, [generateCodeRes])

  useEffect(() => {
    if (!codeGenerated) return
    if (verifiedEmail !== workEmail) setShowVerifyModal(true)

    return () => {
      setShowVerifyModal(false)
    }
  }, [codeGenerated, verifiedEmail, workEmail])

  useEffect(() => {
    if(!isVerifyAgentError) return 
    setErrorContent({ msgText: verifyAgentError.msgTitle, msgTitle: "Error while verifying agent" })
    setAgentVerifyError(true)
  },[isVerifyAgentError])

  useEffect(() => {
    if (!isGenerateCodeError) return
    setErrorContent({ msgText: generateCodeError.msgText, msgTitle: generateCodeError.msgTitle })
    const createAffiliatePayload = {
      AgencyId: '53388',
      PlatformToken: 'SQZInjDbGjm9tN1t',
      agentCity: personalAddress.city,
      agentName: `${registrationForm.firstName} ${registrationForm.lastName}`,
      apptendDate: '2025-12-12',
      distributorId: companyInfo.distributorId,
      agentEmail: registrationForm.workEmail,
      carrierId: '9876',
      producerId: companyInfo.producerId,
      productId: '4127',
      agentFirstName: registrationForm.firstName,
      agentLastName: registrationForm.lastName,
      agentPhone: registrationForm.workAgentPhone,
      agentWorkAddress1: `${workAddress.address1}${workAddress.address2?.trim().length > 0 ? ', ' : ''}${
        workAddress.address2
      }`,
      agentWorkState: workAddress.state,
      agentWorkCity: workAddress.city,
      agentWorkZip: workAddress.zipCode,
    }
    console.log({ createAffiliatePayload })
    createAffiliateCode(createAffiliatePayload)
  }, [isGenerateCodeError, generateCodeError])

  useEffect(() => {
    if (createAffiliateCodeSuccess || isCreatreAffiliateCodeError) {
      if (isCreatreAffiliateCodeError) {
        setErrorContent({ msgText: createAffiliateCodeError.msgText, msgTitle: createAffiliateCodeError.msgTitle })
      }
      setAgentVerifyError(true)
    }
  }, [createAffiliateCodeSuccess, isCreatreAffiliateCodeError])

  useEffect(() => {
    if (!verifyEmailRes) return
    console.log({ verifyEmailRes })
    if (verifyEmailRes.statusCode === 200) {
      setVerificationError(false)
      setVerifiedEmail(workEmail)
      setShowVerifyModal(false)
    } else {
      setVerificationError(true)
    }
  }, [verifyEmailRes])

  useEffect(() => {
    if (!verifyAgentRes) return

    const msgTitle = 'Verification Error'
    const msgText =
      'There is a problem with your contract status with Foresters. Please call Foresters Contracting at 1-866-466-7166 option 4 for assistance.'
    const path = [
      'soapenv:Envelope',
      'soapenv:Body',
      'ProducerInquiryResponse',
      'TXLife',
      'TXLifeResponse',
      'TransResult',
      'ResultCode',
    ]
    const resultCode = path.reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), verifyAgentRes)
    if (resultCode && resultCode['#text'] === 'Failure') {
      setErrorContent({ msgText, msgTitle })
      setAgentVerifyError(true)
      return
    }
    setVerifiedAgentCode(producerId)
    const agentWorkPhone = verifyAgentRes.Phone.length ? verifyAgentRes.Phone.find((i) => i.PhoneTypeCode['#text'] === 'Business') : verifyAgentRes.Phone?.PhoneTypeCode?.["#text"] === 'Business' ? verifyAgentRes.Phone : ""
    const agentPersonalPhone = verifyAgentRes.Phone.length ? verifyAgentRes.Phone.find((i) => i.PhoneTypeCode['#text'] === 'Mobile') : verifyAgentRes.Phone?.PhoneTypeCode?.["#text"] === 'Mobile' ? verifyAgentRes.Phone : ""
    const agentWorkAddress = verifyAgentRes.Address.length
      ? verifyAgentRes.Address.find((i) => i.AddressTypeCode['#text'] === 'Business')
      : verifyAgentRes.Address
    const agentPersonalAddress = verifyAgentRes.Address.length
      ? verifyAgentRes.Address.find((i) => i.AddressTypeCode['#text'] !== 'Business')
      : verifyAgentRes.Address
    setRegistrationForm({
      ...registrationForm,
      firstName: verifyAgentRes.Person.FirstName,
      lastName: verifyAgentRes.Person.LastName,
      workAgentPhone: `${agentWorkPhone?.AreaCode}${agentWorkPhone?.DialNumber}`,
      personalPhone: `${agentPersonalPhone?.AreaCode}${agentPersonalPhone?.DialNumber}`,
    })
    setWorkAddress({
      address1: agentWorkAddress?.Line1,
      address2: agentWorkAddress?.Line2 || agentWorkAddress?.Line3 || '',
      city: agentWorkAddress?.City,
      state: agentWorkAddress?.AddressStateTC['#text'],
      zipCode: agentWorkAddress?.Zip.split(' - ')[0],
    })
    setPersonalAddress({
      address1: agentPersonalAddress?.Line1,
      address2: agentPersonalAddress?.Line2 || agentPersonalAddress?.Line3 || '',
      city: agentPersonalAddress?.City,
      state: agentPersonalAddress?.AddressStateTC['#text'],
      zipCode: agentPersonalAddress?.Zip.split(' - ')[0],
    })
    setAgentVerifyError(false)
    if (verifiedEmail !== workEmail) handleVerifyEmail()
  }, [verifyAgentRes])

  const getIcon = (isChecked) => {
    const smallDotIcon = <CircleIcon sx={{ fontSize: '0.3rem !important', color: '#56677B' }} />
    const checkCircleIcon = <CheckCircleIcon sx={{ fontSize: '0.8rem !important', color: '#3C4FB9' }} />
    const iconToBeRendered = isChecked ? checkCircleIcon : smallDotIcon

    return (
      <div
        style={{
          height: '20px',
          width: '15px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {iconToBeRendered}
      </div>
    )
  }

  const prepareHelperText = (value) => {
    const firstIcon = getIcon(value.length >= 12)
    const secondIcon = getIcon(checkUppercase(value))
    const thirdIcon = getIcon(checkLowerCase(value))
    const fourthIcon = getIcon(checkSpecialChars(value))
    const fifthIcon = getIcon(value === confirmPassword && value.length > 0 && confirmPassword.length > 0)

    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {firstIcon}
          <Typography fontSize={'12px'} color="#56677B">
            Must contain at least 12 characters
          </Typography>
        </div>
        <div style={{ display: 'flex' }}>
          {secondIcon}
          <Typography fontSize={'12px'} color="#56677B">
            Must contain at least 1 uppercase letter
          </Typography>
        </div>
        <div style={{ display: 'flex' }}>
          {thirdIcon}
          <Typography fontSize={'12px'} color="#56677B">
            Must contain at least 1 lowercase letter
          </Typography>
        </div>
        <div style={{ display: 'flex' }}>
          {fourthIcon}
          <Typography fontSize={'12px'} color="#56677B">
            Must contain at least 1 of the following characters: !@#$%^&*()
          </Typography>
        </div>
        <div style={{ display: 'flex' }}>
          {fifthIcon}
          <Typography fontSize={'12px'} color="#56677B">
            Passwords must match
          </Typography>
        </div>
      </div>
    )
  }

  // const handleSubmit = () => {
  //   if (workEmail.length < 5 || !isValidEmail(workEmail)) {
  //     return setError({ ...error, workEmail: true })
  //   }

  //   if (
  //     password.length < 12 ||
  //     !checkUppercase(password) ||
  //     !checkLowerCase(password) ||
  //     !checkSpecialChars(password)
  //   ) {
  //     console.log('password error')
  //     return setError({ workEmail: false, confirmPassword: false, password: true })
  //   }

  //   if (password !== confirmPassword || confirmPassword.length === 0) {
  //     return setError({ workEmail: false, password: false, confirmPassword: true })
  //   }
  //   // handleNext()
  //     // handleSubmit()
  // }

  const handleVerifyEmail = () => {
    if (workEmail.length < 5 || !isValidEmail(workEmail)) return setError({ ...error, email: true })
    if (!codeGenerated) {
      generateCode({ affiliateCode: producerId, email: workEmail, productId: 4127 })
    }
  }

  const handleVerify = () => {
    console.log(verifiedAgentCode)
    if (verifiedAgentCode !== producerId) {
      if (producerId.length === 0) return setError({ ...error, producerId: true })
      if( !firstName|| firstName.trim().length === 0 ) return setError({ ...error, firstName: true })
      if( !lastName|| lastName.trim().length === 0 ) return setError({ ...error, lastName: true })
      setError({ ...error, firstName: false, lastName: false,  producerId: false })
      verifyAgent({
        firstName,
        lastName,
        producerId: producerId,
      })
    } else {
      handleVerifyEmail()
    }
  }

  const handleResendCode = () => {
    generateCode({ affiliateCode, email: workEmail, productId: 4127 })
  }

  const handleBlur = ({ target: { name, value } }) => {
    switch (name) {
      case 'workEmail':
        setVerificationError(false)
        setError((prev) => ({
          ...prev,
          workEmail: !isValidEmail(value),
        }))
        break

      case 'password':
        if (value.length < 12 || !checkUppercase(value) || !checkLowerCase(value) || !checkSpecialChars(value)) {
          console.log('password error')
          return setError((prev) => {
            return { ...prev, password: true }
          })
        } else {
          setError((prev) => {
            return { ...prev, password: false }
          })
        }

        if (confirmPassword.length !== 0) {
          if (value !== confirmPassword) {
            return setError((prev) => {
              return { ...prev, confirmPassword: true }
            })
          } else {
            setError((prev) => {
              return { ...prev, confirmPassword: false }
            })
          }
        }
        break

      case 'confirmPassword':
        console.log(password !== value)
        if (password !== value || value.length === 0) {
          return setError((prev) => {
            return { ...prev, confirmPassword: true }
          })
        } else {
          setError((prev) => {
            return { ...prev, confirmPassword: false }
          })
        }
        break
      default:
        setError((prev) => ({ ...prev, [name]: value.trim() === '' }))
        break
    }
  }

  const emailVerified = workEmail === verifiedEmail
  const agentVerified = producerId === verifiedAgentCode
  return (
    <Box width={'100%'}>
      {isMobile ? <></> : <Typography color="#00314D" fontSize={'16px'} mb={1} textAlign={'start'}>
        Login Information
      </Typography>}
      <Grid container spacing={3} justifyContent={'flex-start'} alignItems={'flex-start'}>
        <Grid item xs={12} md={6}>
          <StyledTextField
            InputLabelProps={{
              shrink: true,
              sx: {
                '&.MuiInputLabel-shrink': {
                  backgroundColor: '#F5F7FF',
                },
              },
            }}
            className="white-box"
            label="First Name"
            placeholder="John"
            value={firstName}
            name="firstName"
            error={error.firstName}
            onChange={(e) => setRegistrationForm({ ...registrationForm, [e.target.name]: e.target.value })}
            // focused={firstName !== ""}
          />
          {error.firstName && (
            <FormHelperText>
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                <Typography fontSize={'12px'} color="#CA303A">
                  Valid First Name required!
                </Typography>
              </div>
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <StyledTextField
            InputLabelProps={{
              shrink: true,
              sx: {
                '&.MuiInputLabel-shrink': {
                  backgroundColor: '#F5F7FF',
                },
              },
            }}
            label="Last Name"
            value={lastName}
            name="lastName"
            placeholder="Doe"
            onChange={(e) => setRegistrationForm({ ...registrationForm, [e.target.name]: e.target.value })}
            error={error.lastName}
            // focused={lastName !== ""}
          />
          {error.lastName && (
            <FormHelperText>
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                <Typography fontSize={'12px'} color="#CA303A">
                  Valid Last Name required!
                </Typography>
              </div>
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <StyledTextField
              InputLabelProps={{
                shrink: true,
                sx: {
                  '&.MuiInputLabel-shrink': {
                    backgroundColor: '#F5F7FF',
                  },
                },
              }}
              label="Foresters Producer Number"
              value={producerId}
              name="producerId"
              placeholder="1234567890"
              type="number"
              error={error.producerId}
              onChange={(e) => setCompanyInfo({ ...companyInfo, [e.target.name]: e.target.value })}
              // focused={producerNumber !== ""}
            />
          </FormControl>

          {error.producerId && (
            <FormHelperText>
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                <Typography fontSize={'12px'} color="#CA303A">
                  Invalid producer number!
                </Typography>
              </div>
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} md={10}>
          <FormControl fullWidth>
            <StyledTextField
              InputLabelProps={{
                shrink: true,
                sx: {
                  '&.MuiInputLabel-shrink': {
                    backgroundColor: '#F5F7FF',
                  },
                },
              }}
              label="Email Address (Login)"
              value={workEmail}
              name="workEmail"
              placeholder="john.doe@email.com"
              onChange={(e) => setRegistrationForm({ ...registrationForm, [e.target.name]: e.target.value })}
              error={error.workEmail}
              onBlur={handleBlur}
              // focused={workEmail !== ""}
            />
          </FormControl>
          {error.workEmail && (
            <FormHelperText>
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                <Typography fontSize={'12px'} color="#CA303A">
                  Invalid email address!
                </Typography>
              </div>
            </FormHelperText>
          )}
          {verificationError && (
            <FormHelperText>
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                <Typography fontSize={'12px'} color="#CA303A">
                  Please verify your email address before creating your account
                </Typography>
              </div>
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} md={2}>
          <Box display="flex" paddingTop={'0.4rem'}>
            <Button
              sx={{
                textTransform: 'none',
                width: { lg: '90%', md: '90%', sm: '90%', xs: '100%' },
                height: '40px',
                backgroundColor: '#C4CAF1',
                color: '#3C4FB9',
                borderRadius: '100px',
                '&:hover': {
                  backgroundColor: '#9BA5DF',
                  color: '#36414E',
                },
                '&:disabled': {
                  backgroundColor: Boolean(emailVerified) && Boolean(agentVerified) ? '#EFFBFA' : '#C4CAF1',
                  color: Boolean(emailVerified) && Boolean(agentVerified) ? '#259A92' : 'white',
                  textTransform: 'none',
                  border: Boolean(emailVerified) && Boolean(agentVerified) ? '1px solid #259A92' : 'none',
                  fontSize: Boolean(emailVerified) && Boolean(agentVerified) ? '12px' : 'normal',
                },
              }}
              onClick={handleVerify}
              disabled={(Boolean(emailVerified) && Boolean(agentVerified)) || error.workEmail || verifyingAgent}
            >
              {Boolean(emailVerified) && Boolean(agentVerified) ? 'Verified!' : 'Verify'}
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          {Boolean(emailVerified) && Boolean(agentVerified) && <FormControl fullWidth>
            <StyledTextField
              InputLabelProps={{
                shrink: true,
                sx: {
                  '&.MuiInputLabel-shrink': {
                    backgroundColor: '#F5F7FF',
                  },
                },
              }}
              label="Create Password"
              value={password}
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="********"
              onBlur={handleBlur}
              onChange={(e) => setRegistrationForm({ ...registrationForm, [e.target.name]: e.target.value })}
              onFocus={() => setShowPasswordChecks(true)}
              error={error.password}
              InputProps={{
                // <-- This is where the toggle button is added.
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton aria-label="toggle password visibility" onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              // focused={password !== ""}
            />
            {error.password && (
              <FormHelperText>
                <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                  <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                  <Typography fontSize={'12px'} color="#CA303A">
                    Password does not fulfill requirements
                  </Typography>
                </div>
              </FormHelperText>
            )}
          </FormControl>}
        </Grid>
        <Grid item xs={12} md={6}>
          {Boolean(emailVerified) && Boolean(agentVerified) && <FormControl fullWidth>
            <StyledTextField
              InputLabelProps={{
                shrink: true,
                sx: {
                  '&.MuiInputLabel-shrink': {
                    backgroundColor: '#F5F7FF',
                  },
                },
              }}
              label="Confirm Password"
              value={confirmPassword}
              type={showConfirmPassword ? 'text' : 'password'}
              name="confirmPassword"
              placeholder="********"
              onBlur={handleBlur}
              onChange={(e) => setRegistrationForm({ ...registrationForm, [e.target.name]: e.target.value })}
              error={error.confirmPassword}
              InputProps={{
                // <-- This is where the toggle button is added.
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                      {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              // focused={confirmPassword !== ""}
            />
            {error.confirmPassword && (
              <FormHelperText>
                <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                  <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                  <Typography fontSize={'12px'} color="#CA303A">
                    Password does not match
                  </Typography>
                </div>
              </FormHelperText>
            )}
          </FormControl>}
        </Grid>
        {showPasswordChecks && (
          <Grid item xs={12}>
            {prepareHelperText(password)}
          </Grid>
        )}
        {/* <Grid item xs={12}>
          <Button
            sx={{
              textTransform: 'none',
              width: { lg: '20%', md: '20%', sm: '50%', xs: '100%' },
              height: '40px',
              backgroundColor: '#3C4FB9',
              color: 'white',
              borderRadius: '100px',
              mt: '10px',
              '&:hover': {
                backgroundColor: '#9BA5DF',
                color: '#36414E',
              },
              '&:disabled': {
                backgroundColor: '#C4CAF1',
                color: 'white',
                textTransform: 'none',
              },
            }}
            disabled={Object.values(error).some((e) => e === true) || !emailVerified || !agentVerified}
            onClick={handleSubmit}
          >
            {isMobile ? 'Done' : 'Next'}
          </Button>
        </Grid> */}
         {Boolean(emailVerified) && Boolean(agentVerified) && (
          <Grid item xs={12}>
            <Box width={'100%'} gap={'1px'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
              <Checkbox
                label="terms-check"
                required
                checked={agreedCheckbox}
                onClick={() => {
                  setAgreedCheckbox(!agreedCheckbox)
                  setError({
                    ...error,
                    agreeToTerms: !!agreedCheckbox,
                  })
                }}
              />
              <Typography fontSize={'14px'}>
                I agree to the{' '}
                <a href="https://www.afficiency.com/terms-of-service" target="_blank" rel="noopener noreferrer">
                  Terms of Service
                </a>{' '}
                and{' '}
                <a href="https://www.afficiency.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>
              </Typography>
            </Box>
          </Grid>
        )}
         <Grid item xs={12}>
          <Button
            sx={{
              textTransform: 'none',
              width: { lg: '40%', md: '50%', sm: '50%', xs: '375px' },
              height: '40px',
              backgroundColor: '#3C4FB9',
              color: 'white',
              borderRadius: '100px',
              mt: '10px',
              position: { xs: 'fixed', sm: 'static' },
              bottom: { xs: '20px', sm: 'auto' },
              left: { xs: '50%', sm: 'auto' },
              transform: { xs: 'translateX(-50%)', sm: 'none' },
              zIndex: { xs: 1000, sm: 'auto' },
              '&:hover': {
                backgroundColor: '#9BA5DF',
                color: '#36414E',
              },
              '&:disabled': {
                backgroundColor: '#C4CAF1',
                color: 'white',
                textTransform: 'none',
              },
            }}
            onClick={handleSubmit}
            // disabled={!errorFree || !agreedCheckbox || !formComplete || loading}
            disabled={!errorFree || !agreedCheckbox || loading}
          >
            {loading ? 
            <CircularProgress size={'1.2rem'} /> : 
            // isMobile ? 'Done' : 
            'Create Account'}
          </Button>
        </Grid>
      </Grid>
      <EmailVerifyModal
        show={showVerifyModal}
        setShow={setShowVerifyModal}
        email={workEmail}
        handleResend={handleResendCode}
        isVerifyError={verifyError || verificationError}
        verifyEmail={verifyEmail}
      />
    </Box>
  )
}

export default FirstRegisterStepV2;